import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AddInterruption from './pages/AddInterruption';
import Register from './pages/Register';
import './styles.css';
import ApplicationList from './pages/ApplicationList';
import NatureList from './pages/NatureList';
import TauxDispo from './pages/Tauxdispo';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/applications" element={<ApplicationList />} />
        <Route path="/natures" element={<NatureList />} />
        <Route path="/add" element={<AddInterruption />} />       
        <Route path="/taux-dispo" element={<TauxDispo />} />
      </Routes>
    </BrowserRouter>
  );
}
